import { mlflowApiClient } from '@/shared/api/core/axios-instance';

import type { RegisteredModelGetResponse } from '@/entities/registered-model/domain/types';

export type GetRegisteredModelParams = {
  name: string;
};

export const getRegisteredModel = async (params: GetRegisteredModelParams): Promise<RegisteredModelGetResponse> => {
  const { data } = await mlflowApiClient.get<RegisteredModelGetResponse>('/ajax-api/2.0/mlflow/registered-models/get', {
    params,
  });
  return data;
};
